import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Link as MuiLink,
} from '@mui/material';
import { CheckCircle, Rocket, Email, ArrowForward } from '@mui/icons-material';

const RegistrationSuccess = () => {
  const location = useLocation();
  const { companyName, username, selectedPlan } = location.state || {};

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper sx={{ maxWidth: 440, mx: 'auto', p: 4, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 64, height: 64, borderRadius: '50%', bgcolor: 'success.50', mb: 3 }}>
          <CheckCircle sx={{ fontSize: 40, color: 'success.main' }} />
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
          Welcome to Firmflow!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Your company <strong>{companyName || 'Your Company'}</strong> has been successfully registered.
        </Typography>

        <Paper variant="outlined" sx={{ p: 2, mb: 3, bgcolor: 'background.default', borderRadius: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
            Your Account Details
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Username: {username || 'your-username'}<br />
            Company: {companyName || 'Your Company'}
          </Typography>
        </Paper>

        <Box sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
            What's Next?
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Email sx={{ fontSize: 20, color: 'primary.main' }} />
              <Typography variant="body2" color="text.secondary">Check your email for verification</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Rocket sx={{ fontSize: 20, color: 'success.main' }} />
              <Typography variant="body2" color="text.secondary">Set up your first client</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CheckCircle sx={{ fontSize: 20, color: 'secondary.main' }} />
              <Typography variant="body2" color="text.secondary">Invite your team members</Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Sign in to activate your free trial and get started.
          </Typography>
          <Button
            component={Link}
            to={`/login?redirect=/pricing?plan=${selectedPlan || 'pro'}%26registered=true`}
            variant="contained"
            color="primary"
            fullWidth
            endIcon={<ArrowForward />}
          >
            Activate Your Free Trial
          </Button>
          <Button
            component={Link}
            to="/login"
            variant="outlined"
            color="success"
            fullWidth
            endIcon={<ArrowForward />}
          >
            Sign In to Your Account
          </Button>
          <Button
            component={Link}
            to="/dashboard"
            variant="outlined"
            fullWidth
          >
            Go to Dashboard
          </Button>
          <Button component={Link} to="/" variant="text" fullWidth>
            Back to Home
          </Button>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
          Need help? Contact our support team at{' '}
          <MuiLink href="mailto:support@firmflow.site">support@firmflow.site</MuiLink>
        </Typography>
      </Paper>
    </Box>
  );
};

export default RegistrationSuccess;
